<div class="stats-page">
  @if (variables?.stats) {
  <h2 class="stats-title">{{variables.stats}}</h2>
  }

  <!-- KPI Cards -->
  <div class="kpi-grid">
    <div class="kpi-card kpi-estimates">
      <div class="kpi-icon">
        <mat-icon svgIcon="Folder" style="width:24px; height:24px;"></mat-icon>
      </div>
      <div class="kpi-body">
        <span class="kpi-value">{{totalEstimates}}</span>
        <span class="kpi-label">{{variables?.estimates || 'Estimaciones'}}</span>
      </div>
    </div>

    <div class="kpi-card kpi-hours">
      <div class="kpi-icon">
        <mat-icon svgIcon="Clock" style="width:24px; height:24px;"></mat-icon>
      </div>
      <div class="kpi-body">
        <span class="kpi-value">{{totalHours | number:'1.0-0'}}</span>
        <span class="kpi-label">{{variables?.effort || 'Esfuerzo'}} (h)</span>
      </div>
    </div>

    <div class="kpi-card kpi-precision">
      <div class="kpi-icon">
        <mat-icon svgIcon="Compliance" style="width:24px; height:24px;"></mat-icon>
      </div>
      <div class="kpi-body">
        <span class="kpi-value"
          [ngClass]="{'precision-good': avgPrecision !== null && avgPrecision >= 0.8 && avgPrecision <= 1.2, 'precision-warn': avgPrecision !== null && (avgPrecision < 0.8 || avgPrecision > 1.2)}">
          {{avgPrecision ? (avgPrecision | number:'1.2-2') : '—'}}
        </span>
        <span class="kpi-label">{{variables?.avgPrecision || 'Precisión media'}}</span>
      </div>
    </div>

    <div class="kpi-card kpi-coverage">
      <div class="kpi-icon">
        <mat-icon svgIcon="certified" style="width:24px; height:24px;"></mat-icon>
      </div>
      <div class="kpi-body">
        <span class="kpi-value">{{imputationCoverage | number:'1.0-0'}}%</span>
        <span class="kpi-label">{{variables?.imputationCoverage || 'Cobertura imputación'}}</span>
      </div>
    </div>
  </div>

  <!-- Charts Grid -->
  <form [formGroup]="formGroup1">
    <!-- Row 1: Activity Timeline + State Donut -->
    <div class="charts-row">
      <div class="chart-card">
        <div class="chart-header">
          <h5>{{variables?.monthlyActivity || 'Actividad mensual'}}</h5>
          <mat-form-field>
            <mat-select formControlName="year1Ctrl" (selectionChange)="onChangeActivityYear($event.value)">
              @for (item of years; track item) {
              <mat-option [value]="item" [title]="item">{{item}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div id="chart-activity" class="chart-container"></div>
      </div>
      <div class="chart-card">
        <div class="chart-header">
          <h5>{{variables?.stateDistribution || 'Distribución por estado'}}</h5>
        </div>
        <div id="chart-state" class="chart-container"></div>
      </div>
    </div>

    <!-- Row 2: Catalog Treemap + Precision Grouped Bar -->
    <div class="charts-row">
      <div class="chart-card">
        <div class="chart-header">
          <h5>{{variables?.catalogUsage || 'Uso de catálogos'}}</h5>
        </div>
        <div id="chart-catalog" class="chart-container"></div>
      </div>
      <div class="chart-card">
        <div class="chart-header">
          <h5>{{variables?.precisionByCatalog || 'Precisión por catálogo'}}</h5>
        </div>
        @if (hasImputationData) {
        <div id="chart-precision" class="chart-container"></div>
        }
        @if (!hasImputationData) {
        <div class="chart-empty">
          <span class="empty-icon">🎯</span>
          <p>{{variables?.noImputationData || 'Sin datos de imputación'}}</p>
          <small>{{variables?.noImputationDataDesc || 'Registra imputaciones reales para analizar
            precisión'}}</small>
        </div>
        }
      </div>
    </div>

    <!-- Row 3: Deviation Bar Chart (full width) -->
    <div class="charts-row charts-row-full">
      <div class="chart-card chart-card-full">
        <div class="chart-header">
          <h5>
            {{variables?.deviationPerEstimate || 'Desviación por estimación'}}
            @if (deviationTotalCount > 20) {
            <small class="chart-subtitle">
              (top 20 de {{deviationTotalCount}})
            </small>
            }
          </h5>
        </div>
        @if (hasImputationData) {
        <div id="chart-deviation" class="chart-container chart-container-tall"></div>
        }
        @if (!hasImputationData) {
        <div class="chart-empty">
          <span class="empty-icon">📊</span>
          <p>{{variables?.noDeviationDataAvailable || 'Sin datos de imputación disponibles'}}</p>
          <small>{{variables?.noDeviationDataAvailableDesc || 'Registra imputaciones reales en tus
            estimaciones para ver este análisis'}}</small>
        </div>
        }
      </div>
    </div>

    <!-- Row 4: Activity Heatmap (full width) -->
    <div class="charts-row charts-row-full">
      <div class="chart-card chart-card-full">
        <div class="chart-header">
          <h5>{{variables?.activityMap || 'Mapa de actividad'}}</h5>
          <div class="chart-header-controls">
            <mat-form-field>
              <mat-select formControlName="heatmapYearCtrl" (selectionChange)="onChangeHeatmapYear($event.value)">
                @for (item of years; track item) {
                <mat-option [value]="item" [title]="item">{{item}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-select formControlName="heatmapCtrl" (selectionChange)="onChangeHeatmapMode($event.value)">
                <mat-option value="technology">{{variables?.technology || 'Tecnología'}}</mat-option>
                <mat-option value="catalog">{{variables?.catalog || 'Catálogo'}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div id="chart-heatmap" class="chart-container chart-container-tall"></div>
      </div>
    </div>
  </form>
</div>